export default __webpack_public_path__ + "static/media/arrowimages.d880d6b9.svg";